module.exports = __webpack_public_path__ + "static/media/Blob.fef86f86.svg";